import React from 'react';
import { useSelector } from 'react-redux';
import useRouter from '../hook/useRouter';
import { IPagination } from '../interface/ICommon';
import { RootState } from '../store';

const PAGE_TYPE = {
    NOMAL: 'nomal',
    FRONT: 'front',
    END: 'end',
    CENTER: 'center',
};

const BtnItem = ({ idx, current }: { idx: number; current: number }) => {
    const { changeParam } = useRouter([]);
    const onNumberClick = () => {
        scrToTop();
        changeParam({ page: idx.toString() });
    };
    if (current === idx) return <span className="number current">{idx}</span>;
    if (current !== idx)
        return (
            <button onClick={onNumberClick} className="number">
                {idx}
            </button>
        );
    return <></>;
};

const scrToTop = () => {
    let tapTop = document.getElementById('container')!;
    window.scrollTo({ top: tapTop.offsetTop + 200, behavior: 'smooth' });
};

export const PaginationPc = ({ dat }: { dat: IPagination | undefined }) => {
    const l10n = useSelector((state: RootState) => state.main.l10n);

    if (!dat || dat.lastPage < 2) {
        return null;
    }
    const { changeParam } = useRouter([]);

    const onPrev = () => {
        let val = dat.page - 5;
        if (val < 1) {
            val = 1;
        }
        scrToTop();
        changeParam({ page: val.toString() });
    };

    const onNext = () => {
        let val = dat.page + 5;
        if (val > dat.lastPage) {
            val = dat.lastPage;
        }
        scrToTop();
        changeParam({ page: val.toString() });
    };

    let pagetype = PAGE_TYPE.NOMAL;
    if (dat.lastPage > 10) {
        if (dat.page < 6) {
            pagetype = PAGE_TYPE.END;
        }
        if (dat.page > dat.lastPage - 5) {
            pagetype = PAGE_TYPE.FRONT;
        }
        if (dat.page > 5 && dat.page < dat.lastPage - 4) {
            pagetype = PAGE_TYPE.CENTER;
        }
    }

    return (
        <div className="ui-pagination is-pc">
            <div className="pagination-list">
                {dat.page < 6 ? (
                    <button className="prev is-disabled" title="">
                        <span>{l10n['price.prev']}</span>
                    </button>
                ) : (
                    <button onClick={onPrev} className="prev" title="Prev 5 pages">
                        <span>{l10n['price.prev']}</span>
                    </button>
                )}

                {pagetype === PAGE_TYPE.NOMAL ? (
                    <>
                        {Array.from({ length: dat.lastPage }).map((_, i) => (
                            <BtnItem key={i + 1} idx={i + 1} current={dat.page} />
                        ))}
                    </>
                ) : (
                    ''
                )}

                {pagetype === PAGE_TYPE.END ? (
                    <>
                        {Array.from({ length: 7 }).map((_, i) => (
                            <BtnItem key={i + 1} idx={i + 1} current={dat.page} />
                        ))}
                        <span className="delimiter">...</span>
                        <BtnItem idx={dat.lastPage} current={dat.page} />
                    </>
                ) : (
                    ''
                )}

                {pagetype === PAGE_TYPE.FRONT ? (
                    <>
                        <BtnItem idx={1} current={dat.page} />
                        <span className="delimiter">...</span>
                        {Array.from({ length: 7 }).map((_, i) => (
                            <BtnItem key={dat.lastPage - 6 + i} idx={dat.lastPage - 6 + i} current={dat.page} />
                        ))}
                    </>
                ) : (
                    ''
                )}

                {pagetype === PAGE_TYPE.CENTER ? (
                    <>
                        <BtnItem idx={1} current={dat.page} />
                        <span className="delimiter">...</span>
                        {Array.from({ length: 5 }).map((_, i) => (
                            <BtnItem key={dat.page - 2 + i} idx={dat.page - 2 + i} current={dat.page} />
                        ))}
                        <span className="delimiter">...</span>
                        <BtnItem idx={dat.lastPage} current={dat.page} />
                    </>
                ) : (
                    ''
                )}

                {dat.page >= dat.lastPage - 4 ? (
                    <button className="next is-disabled" title="">
                        <span>{l10n['price.next']}</span>
                    </button>
                ) : (
                    <button onClick={onNext} className="next" title="Next 5 pages">
                        <span>{l10n['price.next']}</span>
                    </button>
                )}
            </div>
        </div>
    );
};
